var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataMapHeaderText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 985,
    height: 141,
    viewBox: "0 0 985 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M878.969 141V0H934.185C966.594 0.19915 985 19.9152 985 47.7966C985 75.678 966.194 95.1949 933.785 95.1949H908.177V141H878.969ZM908.177 71.6949H928.983C946.389 71.4958 954.791 61.7373 954.591 47.7966C954.791 33.6568 946.389 24.0975 928.983 24.2966H908.177V71.6949Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M758.98 141H727.371L776.185 0H814.197L863.011 141H831.402L820.798 108.737H769.583L758.98 141ZM776.986 85.6356H813.396L795.791 31.8644H794.591L776.986 85.6356Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M558.953 0H594.964L634.575 95.5932H636.176L675.387 0H711.798V141H682.99V48.5932H681.789L644.978 140.203H625.373L588.562 48.5932H587.361V141H558.953V0Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.857 141H361.248L410.062 0H448.074L496.888 141H465.279L454.675 108.737H403.46L392.857 141ZM410.863 85.6356H447.273L429.668 31.8644H428.468L410.863 85.6356Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.68 24.2966V0H368.314V24.2966H325.101V141H295.892V24.2966H252.68Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.678 141H124.068L172.883 0H210.894L259.708 141H228.099L217.496 108.737H166.281L155.678 141ZM173.683 85.6356H210.094L192.488 31.8644H191.288L173.683 85.6356Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6146 141H0V0H50.4148C92.8272 0.19915 119.035 26.4873 118.835 70.5C119.035 114.513 92.8272 141 49.6146 141ZM29.2086 115.907H48.4142C75.4221 115.907 89.6263 101.966 89.6263 70.5C89.6263 39.0339 75.4221 25.2924 48.8143 25.0932H29.2086V115.907Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMapHeaderText);
export default __webpack_public_path__ + "static/media/data-map-header-text.071f2fdb27ad94c172443144da21de85.svg";
export { ForwardRef as ReactComponent };